import React, { useEffect, useState } from "react";
import {
  Modal,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Alert,
  Snackbar,
} from "@mui/material";

import * as XLSX from "xlsx";
import AADService from "../../funcionesAuth.js";


const ModalActualizarAnalista = ({ open, handleClose }) => {
  const AzureADService = new AADService();
  const token = AzureADService.getToken();
  const [plantillaColumnas, setPlantillaColumnas] = useState([
    "idevaluacion",
    "compania",
    "elemento_configuracion",
    "nombre",
    "idactivo",
    "correo",
  ]);
  const [archivosValidos, setArchivosValidos] = useState([]);
  const [guardandoArchivo, setGuardandoArchivo] = useState(null);
  const [mensajeRespuesta, setMensajeRespuesta] = useState("");
  const [mostrarMensaje, setMostrarMensaje] = useState(false);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [analistasViejos, setAnalistasViejos] = useState([]); // Para el POST
  const [analistas, setAnalistas] = useState([]); // Para el GET
  const [analistaAnterior, setAnalistaAnterior] = useState("");
  const [analistaNuevo, setAnalistaNuevo] = useState("");

  const menuProps = {
    PaperProps: {
      style: {
        maxHeight: 300,
        width: 300,
      },
    },
  };

  useEffect(() => {
    const fetchAnalistasViejo = async () => {
      try {
        const response = await fetch(
          process.env.REACT_APP_API_URL +
            "usuariosrol/" +
            localStorage.getItem("idcompania") +
            "/2/",
          {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: "Bearer " + token,

            },
          }
        );

        if (response.ok) {
          const data = await response.json();
          setAnalistasViejos(data);
        } else {
          const errorText = await response.text();
        }
      } catch (error) {
        console.error("Error POST", error);
      }
    };

    const fetchAnalistas = async () => {
      try {
        const response = await fetch(
          process.env.REACT_APP_API_URL +
            "usuariosrol/" +
            localStorage.getItem("idcompania") +
            "/2/",
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + token,

            },
          }
        );
        if (response.ok) {
          const data = await response.json();
          setAnalistas(data);
        } else {
          const errorText = await response.text();
        }
      } catch (error) {
        console.error("Error GET", error);
      }
    };
    if (open) {
      fetchAnalistasViejo();
      fetchAnalistas();
    }
  }, [open]);

  const sendDataActualizar = async () => {
    // Función helper para verificar valores vacíos
    const isEmptyValue = (value) => {
      return (
        value === "" ||
        value === null ||
        value === "NULL" ||
        value === undefined
      );
    };
    // Validar datos manualmente - permitir cambios cuando al menos uno tenga un valor válido
    if (isEmptyValue(analistaAnterior) && isEmptyValue(analistaNuevo)) {
      throw new Error("Datos de analistas no válidos");
    }
    // Convertir "NULL" a null para el backend
    const dataToSend = {
      id_viejo: analistaAnterior === "NULL" ? null : analistaAnterior,
      id_nuevo: analistaNuevo === "NULL" ? null : analistaNuevo,
    };

    const data = JSON.stringify(dataToSend);

    const url =
      process.env.REACT_APP_API_URL +
      "evaluacion/nuevaevaluacion/actualizarAnalistaResponsable/" +
      localStorage.getItem("idcompania") +
      "/";

    try {
      const response = await fetch(url, {
        method: "POST",
        body: data,
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: "Bearer " + token,
        },
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error("❌ Error del servidor:", errorText);
        throw new Error(`Error ${response.status}: ${errorText}`);
      }

      const responseData = await response.json();
      return responseData;
    } catch (err) {
      console.error("🚨 Error completo:", err);
      throw err;
    }
  };

  const descargarResumen = async () => {
    try {
      const idCompania = localStorage.getItem("idcompania");
      if (!idCompania) {
        console.error("ID de compañía no encontrado");
        return;
      }

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}informes/${idCompania}/`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      const resumen = data.resumen;
      const resumenArray = Array.isArray(resumen)
        ? resumen
        : Object.values(resumen);

      const registrosSinAnalista = resumenArray.filter((item) => {
        const analista = item.analista;
        return (
          !analista ||
          analista === "" ||
          analista === null ||
          analista === undefined ||
          (typeof analista === "string" && analista.trim() === "")
        );
      });

      const columnasEsperadas = [
        "idevaluacion",
        "compania",
        "elemento_configuracion",
        "nombre",
        "idactivo",
        "correo",
      ];

      // CORRECCIÓN: Mapear cada item una sola vez
      const datosFiltrados = registrosSinAnalista.map((item) => {
        const objetoFiltrado = {};

        columnasEsperadas.forEach((columna) => {
          if (columna === "correo") {
            // Correo siempre va vacío
            objetoFiltrado[columna] = "";
          } else {
            // Las demás columnas se toman del item (o vacío si no existe)
            objetoFiltrado[columna] = item[columna] || "";
          }
        });

        return objetoFiltrado;
      });
      const idsUnicos = new Set(
        datosFiltrados.map((item) => item.idevaluacion)
      );
      // Eliminar duplicados basándose en idevaluacion (solución temporal)
      const datosSinDuplicados = datosFiltrados.filter(
        (item, index, self) =>
          index === self.findIndex((t) => t.idevaluacion === item.idevaluacion)
      );
      if (datosSinDuplicados.length === 0) {
        alert("No hay registros sin analista asignado para descargar.");
        return;
      }

      descargarArchivo(datosSinDuplicados, "resumen.xlsx");
    } catch (error) {
      console.error("Error al descargar el resumen:", error);
    }
  };

  const descargarArchivo = (datos, nombreArchivo) => {
    const ws = XLSX.utils.json_to_sheet(datos);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Resumen");
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });

    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = nombreArchivo;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url); // Buena práctica: liberar memoria
  };

  const validarYAgregarArchivo = async (file) => {
    const extension = file.name.split(".").pop().toLowerCase();

    if (!["xlsx", "csv"].includes(extension)) {
      alert("Formato no válido");
      return;
    }

    const data = await file.arrayBuffer();
    const workbook = XLSX.read(data);
    const sheetName = workbook.SheetNames[0];
    const sheet = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], {
      defval: "",
    });

    if (!sheet.length) {
      alert("El archivo está vacío o no tiene filas.");
      return;
    }

    // 🔍 Normalizamos las columnas del archivo
    const columnasArchivo = Object.keys(sheet[0] || {}).map((col) =>
      col.trim().toLowerCase()
    );

    // 🔍 Normalizamos también las columnas de la plantilla
    const columnasEsperadas = plantillaColumnas.map((col) =>
      col.trim().toLowerCase()
    );

    const columnasFaltantes = columnasEsperadas.filter(
      (col) => !columnasArchivo.includes(col)
    );

    const valido = columnasFaltantes.length === 0;

    setArchivosValidos((prev) => [
      ...prev,
      {
        nombre: file.name,
        formato: extension,
        valido,
        columnasFaltantes,
        datos: sheet,
      },
    ]);
  };

  const guardarArchivoValido = async (archivo) => {
    setGuardandoArchivo(archivo.nombre);

    try {
      const idCompania = localStorage.getItem("idcompania");
      if (!idCompania) {
        throw new Error("ID de compañía no encontrado");
      }

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}evaluacion/nuevaevaluacion/actualizarAnalistaResponsable/${idCompania}/`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            'Authorization': `Bearer ${token}`, // Si necesitas token
          },
          body: JSON.stringify({
            datos: archivo.datos, // Los datos del archivo validado
          }),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      // Mostrar mensaje de respuesta del backend
      setMensajeRespuesta(
        data.mensaje || data.message || "Archivo guardado correctamente"
      );
      setMostrarMensaje(true);
      // Ocultar mensaje después de 30 segundos
      setTimeout(() => {
        setMostrarMensaje(false);
      }, 30000);
    } catch (error) {
      console.error("Error al guardar archivo:", error);
      setMensajeRespuesta(`Error al guardar el archivo: ${error.message}`);
      setMostrarMensaje(true);
      setTimeout(() => {
        setMostrarMensaje(false);
      }, 4000);
    } finally {
      setGuardandoArchivo(null);
    }
  };

  const handleClickActualizar = () => {
    setOpenConfirmDialog(true);
  };

  const handleCloseConfirm = () => {
    setOpenConfirmDialog(false);
  };

  const handleConfirmActualizar = async () => {
    try {
      const resultado = await sendDataActualizar();
      setOpenConfirmDialog(false);
      handleClose();
    } catch (error) {
      console.error("❌ ERROR ");
    }
  };

  const getNombreAnalista = (idAnalista, listaAnalistas) => {
    const analista = listaAnalistas.find((a) => a.idusuario === idAnalista);
    return analista ? analista.nombre : "";
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        style={{ maxHeight: "100vh", overflowY: "auto" }}
      >
        <div
          style={{
            background: "#fff",
            padding: "30px",
            borderRadius: "10px",
            width: "600px",
            margin: "100px auto",
            display: "flex",
            flexDirection: "column",
            gap: "20px",
          }}
        >
          <h2 style={{ textAlign: "center", fontWeight: "bold" }}>
            Cambiar Responsable
          </h2>

          <FormControl fullWidth>
            <InputLabel
              id="label-analistaV"
              sx={{
                fontSize: "1rem",
                fontWeight: "600",
                color: "#333",
              }}
            >
              Analista Anterior
            </InputLabel>
            <Select
              labelId="label-analistaV"
              label="Analista Anterior"
              value={analistaAnterior}
              onChange={(e) => setAnalistaAnterior(e.target.value)}
              MenuProps={menuProps}
              sx={{
                display: "flex",
                alignItems: "center",
                height: "50px",
              }}
            >
              {analistasViejos.map((analistaViejo) => (
                <MenuItem
                  key={analistaViejo.idusuario}
                  value={analistaViejo.idusuario}
                  style={{
                    textAlign: "center",
                    justifyContent: "center",
                    display: "flex",
                  }}
                >
                  {analistaViejo.nombre}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl fullWidth>
            <InputLabel
              id="label-analista"
              sx={{
                fontSize: "1rem",
                fontWeight: "600",
                color: "#333",
              }}
            >
              Analista Nuevo
            </InputLabel>
            <Select
              labelId="label-analista"
              label="Analista Nuevo"
              value={analistaNuevo}
              onChange={(e) => setAnalistaNuevo(e.target.value)}
              MenuProps={menuProps}
              sx={{
                display: "flex",
                alignItems: "center",
                height: "50px",
              }}
            >
              {/* Opción para valor vacío/null */}
              <MenuItem
                value="NULL"
                style={{
                  textAlign: "center",
                  justifyContent: "center",
                  display: "flex",
                  fontStyle: "italic",
                  color: "#666",
                }}
              >
                Sin Responsable
              </MenuItem>

              {analistas
                .filter((analista) => analista.idusuario !== analistaAnterior)
                .map((analista) => (
                  <MenuItem
                    key={analista.idusuario}
                    value={analista.idusuario}
                    title={analista.nombre}
                    style={{
                      textAlign: "center",
                      justifyContent: "center",
                      display: "flex",
                    }}
                  >
                    <div
                      style={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {analista.nombre}
                    </div>
                  </MenuItem>
                ))}
            </Select>
          </FormControl>

          <div
            style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}
          >
            <Button
              onClick={handleClickActualizar}
              className="botonPositivo"
              style={{
                backgroundColor: "#4caf50",
                color: "#fff",
                borderRadius: "8px",
                height: "40px",
                minWidth: "200px",
                padding: "0 20px",
                fontWeight: "500",
                textTransform: "none",
                fontSize: "14px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              Actualizar
            </Button>
          </div>
          <div
            style={{ height: "1px", backgroundColor: "#000", margin: "20px 0" }}
          />

          <h2 style={{ textAlign: "center", fontWeight: "bold" }}>
            Asignar Responsable Eros
          </h2>
          <div>
            <table className="table table-bordered table-hover mt-3">
              <thead className="table-dark">
                <tr>
                  <th>Nombre</th>
                  <th>Formato</th>
                  <th>Descargar informe</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Informe sin analista responsable</td>
                  <td>
                    <span className="badge bg-secondary">XLSX</span>
                  </td>
                  <td>
                    <button
                      className="btn btn-success btn-sm"
                      onClick={() => descargarResumen([{}], "resumen.xlsx")}
                    >
                      Descargar
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="mb-3">
            <label>Subir archivo para guardar datos</label>
            <input
              type="file"
              accept=".xlsx,.csv"
              onChange={(e) => validarYAgregarArchivo(e.target.files[0])}
              className="form-control"
            />
          </div>
          <div>
            {/* Mensaje del backend */}
            <Snackbar
              open={mostrarMensaje}
              autoHideDuration={4000}
              onClose={() => setMostrarMensaje(false)}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
              <Alert
                onClose={() => setMostrarMensaje(false)}
                severity={
                  mensajeRespuesta?.includes("Error") ? "error" : "success"
                }
                variant="filled"
              >
                {mensajeRespuesta}
              </Alert>
            </Snackbar>

            <table className="table table-bordered table-hover mt-3">
              <thead className="table-dark">
                <tr>
                  <th>Nombre</th>
                  <th>Formato</th>
                  <th className="text-center">Estado</th>
                </tr>
              </thead>
              <tbody>
                {archivosValidos.map((archivo, idx) => (
                  <tr key={idx}>
                    <td>
                      <div className="d-flex align-items-center">
                        <i className="fas fa-file me-2 text-muted"></i>
                        {archivo.nombre}
                      </div>
                    </td>
                    <td>
                      <span className="badge bg-secondary">
                        {archivo.formato.toUpperCase()}
                      </span>
                    </td>
                    <td className="text-center">
                      {archivo.valido ? (
                        <button
                          className="btn btn-success btn-sm d-flex align-items-center mx-auto"
                          onClick={() => guardarArchivoValido(archivo)}
                          disabled={guardandoArchivo === archivo.nombre}
                        >
                          {guardandoArchivo === archivo.nombre ? (
                            <>
                              <CircularProgress
                                size={16}
                                thickness={4}
                                sx={{
                                  color: "white",
                                  marginRight: "8px",
                                }}
                              />
                              Guardando...
                            </>
                          ) : (
                            <>
                              <i className="fas fa-save me-2"></i>
                              Guardar
                            </>
                          )}
                        </button>
                      ) : (
                        <div className="text-danger">
                          <div className="d-flex align-items-center justify-content-center mb-2">
                            <i className="fas fa-exclamation-triangle me-2"></i>
                            <strong>Columnas faltantes:</strong>
                          </div>
                          <ul className="list-unstyled mb-0 small">
                            {archivo.columnasFaltantes.map((col, i) => (
                              <li key={i} className="mb-1">
                                <i className="fas fa-times text-danger me-1"></i>
                                {col}
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </Modal>
      <Dialog
        open={openConfirmDialog}
        onClose={handleCloseConfirm}
        maxWidth="sm"
        PaperProps={{
          style: {
            borderRadius: "12px",
            padding: "8px",
          },
        }}
      >
        <DialogTitle
          style={{
            fontSize: "18px",
            fontWeight: "600",
            color: "#333",
            paddingBottom: "8px",
          }}
        >
          Confirmar actualización
        </DialogTitle>
        <DialogContent>
          <p
            style={{
              margin: "0",
              fontSize: "14px",
              color: "#666",
              lineHeight: "1.5",
            }}
          >
            {analistaNuevo === "" ||
            analistaNuevo === null ||
            analistaNuevo === "NULL" ? (
              // Caso: Eliminar asignación
              <>
                ¿Estás seguro que quieres cambiar de{" "}
                <span
                  style={{
                    fontWeight: "600",
                    color: "#d32f2f",
                  }}
                >
                  {getNombreAnalista(analistaAnterior, analistasViejos) ||
                    "Sin asignar"}
                </span>{" "}
                por{" "}
                <span
                  style={{
                    fontWeight: "600",
                    color: "#ff9800",
                  }}
                >
                  Sin Responsable
                </span>
                ?
              </>
            ) : (
              // Caso: Cambiar a otro analista
              <>
                ¿Estás seguro que quieres cambiar de{" "}
                <span
                  style={{
                    fontWeight: "600",
                    color: "#d32f2f",
                  }}
                >
                  {getNombreAnalista(analistaAnterior, analistasViejos) ||
                    "Sin asignar"}
                </span>{" "}
                por{" "}
                <span
                  style={{
                    fontWeight: "600",
                    color: "#4caf50",
                  }}
                >
                  {getNombreAnalista(analistaNuevo, analistas)}
                </span>
                ?
              </>
            )}
          </p>
        </DialogContent>
        <DialogActions style={{ padding: "16px 24px" }}>
          <Button
            onClick={handleCloseConfirm}
            style={{
              color: "#666",
              textTransform: "none",
              fontSize: "14px",
              fontWeight: "500",
            }}
          >
            Descartar
          </Button>
          <Button
            onClick={handleConfirmActualizar}
            variant="contained"
            style={{
              backgroundColor: "#4caf50",
              color: "white",
              textTransform: "none",
              fontSize: "14px",
              fontWeight: "500",
              borderRadius: "6px",
            }}
          >
            Seguro
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ModalActualizarAnalista;
